module.exports = __webpack_public_path__ + "static/media/pp_image_portal.726fd78d.jpg";